import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { ElioLoadingComponent } from '@elio/shared/ui/loading';
import { ComponentStore } from '@ngrx/component-store';
import { map } from 'rxjs';

@Component({
  selector: 'elio-lazy-loaded-chunk-loader',
  standalone: true,
  imports: [NgIf, AsyncPipe, ElioLoadingComponent],
  template: ` <section *ngIf="loading$ | async" class="absolute inset-0 opacity-60 bg-white z-50">
    <elio-loading></elio-loading>
  </section>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioLazyLoadedChunkLoaderComponent extends ComponentStore<{ loading: boolean }> implements OnInit {
  loading$ = this.select((state) => state.loading);

  constructor(private router: Router) {
    super({ loading: false });
  }

  ngOnInit(): void {
    this.updateLoading(
      this.router.events.pipe(
        map((event) => {
          if (event instanceof RouteConfigLoadStart) {
            return true;
          } else if (event instanceof RouteConfigLoadEnd) {
            return false;
          }
          return false;
        })
      )
    );
  }

  private readonly updateLoading = this.updater((state, loading: boolean) => ({
    ...state,
    loading,
  }));
}
